import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { useTreeViewStyles } from 'components/WorkspaceEditor/styles'
import React, { memo } from 'react'

interface KeyedTextProps {
    /** The keyed text value (typically a label followed by colon) */
    keyedText: string
    /** The class name to apply styling */
    classes?: string
    /** Optional test id for testing */
    'data-testid'?: string
}

/**
 * A component that renders a keyed text.
 * @param {KeyedTextProps} props - Props for the component.
 */
export const KeyedText = memo<KeyedTextProps>(
    ({ keyedText, classes, 'data-testid': dataTestId }) => {
        const { readOnlyCursor } = useTreeViewStyles()
        return (
            <Typography
                variant="caption"
                className={clsx(classes, readOnlyCursor)}
                data-testid={dataTestId || 'keyed-text'}
            >
                {keyedText}
            </Typography>
        )
    }
)
